import React, { useState, useRef, useEffect } from "react";
import { TimelineMax, TweenLite } from "gsap";

const UsersAnim = (props) => {
    const timeline = new TimelineMax({ paused: true });
    const [buildAnim, setBuildAnim] = useState(null);

    const user1 = useRef(null);
    const user2 = useRef(null);


    useEffect(() => {
        setBuildAnim(
            timeline
                .add(TweenLite.to([user1.current, user2.current], 0, {opacity:0}))

                .add(TweenLite.to(user1.current, 0,  {x:'-=70', position:0, opacity:0}))
                .add(TweenLite.to(user1.current, 0.5, {x:0, position:1,ease:'Power1.easeOut', opacity:1}))
                .add(TweenLite.to(user2.current, 0,  { position:0, opacity:0}))
                .add(TweenLite.to(user2.current, 0.8, { position:1, opacity:1}))

                .play()
        );
    }, []);

        return (
        <div>
            <svg onMouseEnter={() => buildAnim.restart()} style={{cursor:'pointer'}} height={props.height} viewBox="0 0 60 60"
                 preserveAspectRatio="xMinYMin meet">

                <g>
                    <path
                        fill={props.fill}
                        stroke={props.fill}
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        d="M26,7c-2.15,0.04-4.17,0.25-4.8,2c-2.63-0.06-3.25,1.44-4.2,3.58s-0.39,7.72,0.3,9.73c-1.54,0.94-1.04,5.44,1.2,5.58c0.26,1.17,0.48,4.22,2.4,5.3v3.9C20.83,40.5,8.76,43.16,7,45c0,0,0,3.55,0,6h38c0-2.2,0-6,0-6c-1.76-1.84-13.58-4.5-13.8-7.9v-3.9c1.92-1.08,2.25-4.33,2.5-5.5c2.24-0.25,2.64-4.55,1.1-5.48c0.69-2.02,1.45-7.49,0.5-9.63S32,7,26,7z"
                        ref={user1}
                    />

                    <path
                        fill="none"
                        stroke={props.fill}
                        strokeWidth="2"
                        strokeMiterlimit="10"
                        d="M45,49h8c0-1.9,0-7.18,0-7.18c-1.52-1.59-11.73-3.89-11.92-6.82v-3.37c1.66-0.94,1.94-3.74,2.16-4.75c1.93-0.21,2.28-3.93,0.95-4.74c0.6-1.74,1.25-6.47,0.43-8.32C43.8,11.97,41.77,9,36.59,9c-1.07,0.02-2.44,0.09-3.52,0.44"
                        ref={user2}
                    />
                </g>
            </svg>



        </div>
    );
};

export default UsersAnim;